export default __webpack_public_path__ + "static/media/login-page-background.6f010c64.jpg";